import { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function FloppyDishIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="M6 20a.97.97 0 0 1-.713-.288A.97.97 0 0 1 5 19q0-.424.287-.712A.97.97 0 0 1 6 18h12q.424 0 .712.288.288.287.288.712 0 .424-.288.712A.97.97 0 0 1 18 20zm.7-3.5q-.725 0-1.288-.475a1.96 1.96 0 0 1-.687-1.2l-1-6.35a.6.6 0 0 0-.113.013.6.6 0 0 1-.112.012q-.625 0-1.062-.437A1.45 1.45 0 0 1 2 7q0-.625.438-1.062A1.45 1.45 0 0 1 3.5 5.5q.624 0 1.063.438Q5 6.374 5 7q0 .175-.037.325-.039.15-.088.275L8 9l3.125-4.275A1.54 1.54 0 0 1 10.5 3.5q0-.625.438-1.062A1.45 1.45 0 0 1 12 2q.624 0 1.063.438.437.436.437 1.062 0 .375-.175.7a1.54 1.54 0 0 1-.45.525L16 9l3.125-1.4a2 2 0 0 1-.087-.275A1.3 1.3 0 0 1 19 7q0-.625.438-1.062A1.45 1.45 0 0 1 20.5 5.5q.625 0 1.063.438Q22 6.374 22 7q0 .624-.437 1.063A1.45 1.45 0 0 1 20.5 8.5a.6.6 0 0 1-.113-.012.6.6 0 0 0-.112-.013l-1 6.35a1.96 1.96 0 0 1-.687 1.2 1.94 1.94 0 0 1-1.288.475z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
